import _ from 'lodash'
import { withCompInfo } from '@wix/editor-elements-integrations'
import type { StylableButtonProps, StylableButtonDefinition } from './StylableButton'
import type { LinkProps } from '@wix/thunderbolt-becky-types'

export const props = withCompInfo<StylableButtonProps, StylableButtonDefinition>()(
	['compData', 'compProps', 'compStylableClass', 'experiments'],
	({ compData, compProps, compStylableClass }) => {
		const { link, label = '', a11y = {}, svgId, isIconAnimated, animatedIcon = {} } = compData as any
		const { isDisabled } = compProps as any

		const animationDuration = animatedIcon.animationDuration
		const svgIdAnimationSelected = animatedIcon.svgIdAnimationSelected
		const svgAnimatedString = (isIconAnimated && svgIdAnimationSelected && svgIdAnimationSelected.content) || ''

		const a11yPanelData = _.pick(a11y, ['expanded', 'haspopup', 'tabindex', 'pressed', 'live', 'label', 'disabled'])
		const isPopup = link && !!link.linkPopupId
		if (isPopup) {
			a11yPanelData.haspopup = 'dialog'
		}

		return {
			link: link || ({} as LinkProps),
			type: link && link.type === 'FormSubmitButtonLink' ? 'submit' : 'button',
			svgString: (!isIconAnimated && svgId.content) || '',
			animationDuration,
			svgAnimatedString,
			isIconAnimated,
			label,
			a11y: a11yPanelData,
			className: compStylableClass,
			isDisabled,
		}
	}
)
